import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { database, auth } from './firebase';
import { ref, onValue, update } from 'firebase/database';
import { signOut } from 'firebase/auth';
import { FaCheck, FaTimes, FaEnvelope, FaPhone, FaCode  } from 'react-icons/fa';
import AdminNavbar from './components/AdminNavbar';

const AdminContainer = styled.div`
  width: 100vw;
  margin: 2rem auto;
  padding: 1rem;
`;

const AdminTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 0rem;
  color: #333;
  margin-top: 3rem;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-left: 1rem;
  }
`;

// const AdminNav = styled.nav`
//   display: flex;
//   gap: 1rem;
//   flex-wrap: wrap;

//   @media (max-width: 1045px) {
//     display: ${props => props.isOpen ? 'flex' : 'none'};
//     flex-direction: column;
//     width: 100%;
//     margin-top: 1rem;
//     gap: 0.5rem;
//   }
// `;

const AdminNavLink = styled.button`
  padding: 0.75rem 1.5rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  text-decoration: none;
  transition: background 0.3s ease;

  &:hover {
    background: #0056b3;
  }
`;

// const LogoutButton = styled(AdminNavLink)`
//   background: #dc3545;
//   &:hover {
//     background: #c82333;
//   }
// `;

const MessagesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
      scale: 0.8;
      position: relative;
      left: 0px;
      top: 0px;
    }

  @media (max-width: 824px) {
      scale: 0.8;
      position: relative;
      left: 0px;
      top: 0px;
  }
  @media (max-width: 768px) {
      scale: 0.9;
      position: relative;
      left: -30px;
      top: 0px;
  }

  @media (max-width: 590px) {
      scale: 0.55;
      position: relative;
      left: -135px;
      top: -50px;
    }
`;

const TableHeader = styled.th`
  padding: 1rem;
  text-align: left;
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background: #f8f9fa;
  }
`;

const TableCell = styled.td`
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
`;

// const MessageContent = styled.div`
//   max-width: 300px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;

//   @media (max-width: 590px) {
//     max-width: 150px;
//   }
// `;

// const ApplicationsSection = styled.div`
//   margin-top: 2rem;
//   padding: 1rem;
//   background: white;
//   border-radius: 10px;
//   box-shadow: 0 0 10px rgba(0,0,0,0.1);
// `;

// const ApplicationsTitle = styled.h2`
//   font-size: 1.5rem;
//   margin-bottom: 1rem;
//   color: #333;
// `;

const ApplicationCard = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  background: #f8f9fa;

  @media (max-width: 768px) {
    width: 77vw;
  }
`;

const ApplicationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

const ApplicationName = styled.h3`
  font-size: 1.2rem;
  color: #333;
  margin: 0;
`;

const ApplicationStatus = styled.span`
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.9rem;
  background: ${props => 
    props.status === 'approved' ? '#d4edda' : 
    props.status === 'rejected' ? '#f8d7da' : 
    '#fff3cd'};
  color: ${props => 
    props.status === 'approved' ? '#155724' : 
    props.status === 'rejected' ? '#721c24' : 
    '#856404'};
`;

const ApplicationDetails = styled.div`
  margin-top: 0.5rem;
`;

const DetailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
  color: #666;
`;

const ApplicationActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const ActionButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
`;

const ApproveButton = styled(ActionButton)`
  background: #28a745;
  color: white;
`;

const RejectButton = styled(ActionButton)`
  background: #dc3545;
  color: white;
`;

const SkillsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

const SkillTag = styled.span`
  background: #e9ecef;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  color: #495057;
`;

const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-top: 1rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const DashboardSection = styled.div`
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  height: fit-content;

  @media (max-width: 768px) {
    width: 90vw;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #333;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #f0f0f0;

  @media (max-width: 768px) {
    font-size: 1.2rem;
    text-align: left;
  }
`;

// const MessageRow = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
//   gap: 1rem;
//   padding: 1rem;
//   border-bottom: 1px solid #eee;
//   align-items: start;
//   min-height: fit-content;
//   height: auto;

//   &:last-child {
//     border-bottom: none;
//   }

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//     gap: 0.5rem;
//     padding: 0.75rem;
//   }
// `;

const MessageCell = styled.div`
  color: #333;
  font-size: 0.9rem;
  word-break: break-word;
  white-space: normal;
  overflow: visible;
  height: auto;
  min-height: 1.5rem;
  line-height: 1.4;
`;

const MessageDescription = styled(MessageCell)`
  grid-column: span 2;
  white-space: normal;
  overflow: visible;
  height: auto;
  min-height: 1.5rem;
  line-height: 1.4;
  padding-right: 1rem;

  @media (max-width: 768px) {
    grid-column: span 1;
    padding-right: 0;
  }
`;

const AdminDashboard = () => {
  const [messages, setMessages] = useState([]);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        navigate('/admin');
      } else {
        const messagesRef = ref(database, 'messages');
        onValue(messagesRef, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            const messagesList = Object.entries(data).map(([id, message]) => ({
              id,
              ...message
            }));
            setMessages(messagesList);
          }
        });

        const applicationsRef = ref(database, 'new-member-application');
        onValue(applicationsRef, (snapshot) => {
          const data = snapshot.val();
          if (data) {
            const applicationsList = Object.entries(data).map(([id, application]) => ({
              id,
              ...application
            }));
            setApplications(applicationsList);
          } else {
            setApplications([]);
          }
          setLoading(false);
        });
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // const handleLogout = async () => {
  //   try {
  //     await signOut(auth);
  //     navigate('/admin');
  //   } catch (error) {
  //     console.error('Error logging out:', error);
  //   }
  // };

  const handleStatusChange = async (applicationId, newStatus) => {
    try {
      const applicationRef = ref(database, `new-member-application/${applicationId}`);
      await update(applicationRef, { status: newStatus });
    } catch (error) {
      console.error('Error updating application status:', error);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <AdminContainer>
      <AdminNavbar />
      <AdminTitle>Admin Dashboard</AdminTitle>
      <DashboardGrid>
        <DashboardSection>
          <SectionTitle>New Member Applications</SectionTitle>
          {loading ? (
            <p>Loading applications...</p>
          ) : applications.length === 0 ? (
            <p>No applications found.</p>
          ) : (
            applications.map((application) => (
              <ApplicationCard key={application.id}>
                <ApplicationHeader>
                  <ApplicationName>{application.fullName}</ApplicationName>
                  <ApplicationStatus status={application.status}>
                    {application.status}
                  </ApplicationStatus>
                </ApplicationHeader>
                
                <ApplicationDetails>
                  <DetailRow>
                    <FaEnvelope /> {application.email}
                  </DetailRow>
                  <DetailRow>
                    <FaPhone /> {application.phone}
                  </DetailRow>
                  <DetailRow>
                    <p>{application.description}</p>
                  </DetailRow>
                  <SkillsList>
                    {application.technicalSkills.map((skill, index) => (
                      <SkillTag key={index}>
                        <FaCode /> {skill}
                      </SkillTag>
                    ))}
                  </SkillsList>
                  <DetailRow>
                    Applied on: {formatDate(application.createdAt)}
                  </DetailRow>
                </ApplicationDetails>

                {application.status === 'pending' && (
                  <ApplicationActions>
                    <ApproveButton onClick={() => handleStatusChange(application.id, 'approved')}>
                      <FaCheck /> Approve
                    </ApproveButton>
                    <RejectButton onClick={() => handleStatusChange(application.id, 'rejected')}>
                      <FaTimes /> Reject
                    </RejectButton>
                  </ApplicationActions>
                )}
              </ApplicationCard>
            ))
          )}
        </DashboardSection>

        <DashboardSection>
          <SectionTitle>Messages</SectionTitle>
          <MessagesTable>
            <thead>
              <tr>
                <TableHeader>Name</TableHeader>
                <TableHeader>Email</TableHeader>
                <TableHeader>Message</TableHeader>
                <TableHeader>Date</TableHeader>
              </tr>
            </thead>
            <tbody>
              {messages.map((message) => (
                <TableRow key={message.id}>
                  <TableCell>{message.name}</TableCell>
                  <TableCell>{message.email}</TableCell>
                  <TableCell>
                    <MessageDescription title={message.description}>
                      {message.description}
                    </MessageDescription>
                  </TableCell>
                  <TableCell>{new Date(message.createdAt).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </tbody>
          </MessagesTable>
        </DashboardSection>
      </DashboardGrid>
    </AdminContainer>
  );
};

export default AdminDashboard; 